import { useTranslation } from '@mint-lib/i18n';
import { useProfile } from '@mint-lib/profile-helpers';

export const useNumberLocalize = () => {
  const { i18n } = useTranslation('@mint-lib/formatting-hooks');
  const { getProfileField } = useProfile();

  const locale = (
    getProfileField('formattingConfig')?.numbersFormat
      ? getProfileField('formattingConfig')?.numbersFormat
      : i18n.language
  ) as string;

  return locale;
};
